import { Query } from '@/types/queryTypes'

export default function cleanPrepaymentQueryParams(query: Query) {
  const cleanedQuery = { ...query }

  ;['force-prepayment', 'token', 'redirectResult'].forEach((param) => {
    delete cleanedQuery[param]
  })

  return cleanedQuery
}
